const PRODUCTION_IMAGE_BASE = 'https://braxohub.com/images';

const trimTrailingSlashes = (value: string) => value.replace(/\/+$/, '');

const getMenuImageBaseUrl = (): string => {
  const configuredImageBaseUrl = trimTrailingSlashes(process.env.REACT_APP_IMAGE_URL || '');
  if (configuredImageBaseUrl) {
    return configuredImageBaseUrl;
  }
  return PRODUCTION_IMAGE_BASE;
};

export const getMenuImageUrl = (imagePath?: string | null): string => {
  if (!imagePath) return '';

  const cleanPath = imagePath.trim();

  // Already a full absolute URL — return as-is
  if (cleanPath.startsWith('http://') || cleanPath.startsWith('https://')) {
    return cleanPath;
  }

  const imageBaseUrl = getMenuImageBaseUrl();

  // Extract just the filename, stripping any leading path segments
  // Handles: /images/foo.png  |  /uploads/foo.png  |  foo.png
  const filename = cleanPath.split('?')[0].split('#')[0].split('/').filter(Boolean).pop();

  return filename ? `${imageBaseUrl}/${filename}` : '';
};
